

function Prohibited() {
    return (
        <div>
            <h1>Prohibited Auction Items</h1>
            <p>BCA will not list any of the following items for auction.</p>
            <ul className="prohibitedList">
                <li>Anything to do with Alcohol or Drugs, even if it’s legal.</li>
                <li>Anything to do with Gambling or any Gaming.</li>
                <li>Anything to do with items that are not owned by the seller or proven that they are the agent/representative for that item.</li>
                <li>Any item that requires international shipping, if item sells outside of the place or country it’s in.</li>
            </ul>
        </div>
    )
}

export default Prohibited;